// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminUserManagement-commonHeaderAdmin-UM9lq {
	position: fixed !important;
}

.AdminUserManagement-adminLayout-HBMxc {
	padding-top: 64px !important;
}

.AdminUserManagement-box-EZer3 h2 {
	font-size: 21px;
	font-weight: 600;
}

.AdminUserManagement-exportLink-luVwH {
	margin-bottom: -29px;
}

.AdminUserManagement-blockCenter-Jav9G {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AdminUserManagement-panelHeader-PWkFN {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AdminUserManagement-currencyselect-XmPjW {
	width: 100%;
	margin-right: 0px;
}

.AdminUserManagement-panelHeader-PWkFN {
	overflow: hidden;
	position: relative;
}

.AdminUserManagement-mar0-gka2Z {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AdminUserManagement-blockCenter-Jav9G {
		padding: 0px;
	}

	.AdminUserManagement-panelHeader-PWkFN {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AdminUserManagement-sideAdminPageWrapper-L5Wb5 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AdminUserManagement-panelHeader-PWkFN {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AdminUserManagement-table-ZFskH {
	display: table;
}

.AdminUserManagement-tableRow-LliAI {
	display: table-row;
}

.AdminUserManagement-tableCell-OJr5R {
	display: table-cell;
	float: none;
}

.AdminUserManagement-formGroup-f5j8g {
	margin-bottom: 6px;
}

.AdminUserManagement-select-C9_fK {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AdminUserManagement-noMargin-ly1st {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AdminUserManagement-exportLink-luVwH {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminUserManagement-labelTextNew-y_Q4N {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminUserManagement-displayInline-bGpij {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AdminUserManagement-btnUPdate-n2yH_ {
	display: inline-block;
}

.AdminUserManagement-btnModalDelete-YnaFM {
	display: inline-block;
	margin-left: 15px;
}

.AdminUserManagement-radioBtn-Cvl1g {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AdminUserManagement-backgroundImg-Nn3uu {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AdminUserManagement-btnUPdate-n2yH_ {
		display: block;
		margin-bottom: 12px;
	}

	.AdminUserManagement-btnModalDelete-YnaFM {
		display: block;
		margin-left: 0px;
	}

	.AdminUserManagement-btnWidth-VVL0i {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AdminUserManagement-bannerImageBg-Ai7GH {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AdminUserManagement-bannerDelete-CB9F9 {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AdminUserManagement-modalRoot-COWDE {
	padding: 32px;
}

.AdminUserManagement-modalBorderBottom-MM6vY {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AdminUserManagement-logInModalBody-OWyGR {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AdminUserManagement-exportSection-Ksscv {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AdminUserManagement-exportSectionGridSub-iQPvr {
	grid-template-columns: 50% 49% !important;
}

.AdminUserManagement-exportText-WQoZw {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AdminUserManagement-exportLinkImg-sgwe4 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AdminUserManagement-vtrMiddle-kbYYU {
	vertical-align: middle;
}

.AdminUserManagement-exportImg-Oorff {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminUserManagement-profileViewlabel-uVHPb {
	display: inline-block;
	width: 38%
}

.AdminUserManagement-profileViewMainContent-iBBZD {
	display: inline-block;
	width: 62%;
}

.AdminUserManagement-profileViewMain-o3C6R {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AdminUserManagement-profileViewInner-loSub {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminUserManagement-profileImageSection-aDJgl {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AdminUserManagement-lastviewInner-wZIff {
	padding: 10px;
}

.AdminUserManagement-whyHostHoriLine-zHFDt {
	margin: 30px 0;
}

.AdminUserManagement-tableGrid-YWwhP {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AdminUserManagement-headingContent-R9_Il {
	font-size: 18px;
	font-weight: 500;
}

.AdminUserManagement-refundTextColor-2Zn03 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AdminUserManagement-dividerLine-OfboY {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AdminUserManagement-smallContent-DrTuW {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminUserManagement-sideAdminPageWrapper-L5Wb5 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AdminUserManagement-sideAdminPageWrapper-L5Wb5 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AdminUserManagement-exportSection-Ksscv {
		grid-template-columns: 100%;
	}

	.AdminUserManagement-exportSectionGridSub-iQPvr {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AdminUserManagement-profileViewlabel-uVHPb {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminUserManagement-profileViewMainContent-iBBZD {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AdminUserManagement-ChangeToUpperCase-GUwPY {
	text-transform: uppercase
}

.AdminUserManagement-noBorder-t5Wmj {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AdminUserManagement-siteAdminHeading-VmsMD {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminUserManagement-siteAdminSubHeading-vMsud {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AdminUserManagement-adminFormDivider-BXF8z {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AdminUserManagement-space1-vepwL {
	margin-bottom: 6px !important;
}

.AdminUserManagement-space2-HfDXd {
	margin-bottom: 12px !important;
}

.AdminUserManagement-space3-uMtkS {
	margin-bottom: 18px !important;
}

.AdminUserManagement-space4-n2aUo {
	margin-bottom: 24px !important;
}

.AdminUserManagement-space5-uJytu {
	margin-bottom: 30px !important;
}

.AdminUserManagement-space6-mYwqS {
	margin-bottom: 36px !important;
}

.AdminUserManagement-space7-BIDKI {
	margin-bottom: 42px !important;
}

.AdminUserManagement-spaceTop8-m7k2y {
	margin-bottom: 48px !important;
}

.AdminUserManagement-spaceTop1-DGQT5 {
	margin-top: 6px !important;
}

.AdminUserManagement-spaceTop2-mEzeG {
	margin-top: 12px !important;
}

.AdminUserManagement-spaceTop3-XVHba {
	margin-top: 18px !important;
}

.AdminUserManagement-spaceTop4-G_inQ {
	margin-top: 24px !important;
}

.AdminUserManagement-spaceTop5-Sdnal {
	margin-top: 30px !important;
}

.AdminUserManagement-spaceTop6-x47A9 {
	margin-top: 36px !important;
}

.AdminUserManagement-spaceTop7-duZtI {
	margin-top: 42px !important;
}

.AdminUserManagement-spaceTop8-m7k2y {
	margin-top: 48px !important;
}

.AdminUserManagement-noMargin-ly1st {
	margin: 0px !important;
}

.AdminUserManagement-padding1-rRNf4 {
	padding-bottom: 6px !important;
}

.AdminUserManagement-padding2-lJ_0d {
	padding-bottom: 12px !important;
}

.AdminUserManagement-padding3-N5pa1 {
	padding-bottom: 18px !important;
}

.AdminUserManagement-padding4-cIMvk {
	padding-bottom: 24px !important;
}

.AdminUserManagement-padding5-YQlfN {
	padding-bottom: 30px !important;
}

.AdminUserManagement-padding6-uykWZ {
	padding-bottom: 36px !important;
}

.AdminUserManagement-padding7-BM7u2 {
	padding-bottom: 42px !important;
}

.AdminUserManagement-paddingTop1-HyE1D {
	padding-top: 6px !important;
}

.AdminUserManagement-paddingTop2-B4UtC {
	padding-top: 12px !important;
}

.AdminUserManagement-paddingTop3-hB7jL {
	padding-top: 18px !important;
}

.AdminUserManagement-paddingTop4-ugJJc {
	padding-top: 24px !important;
}

.AdminUserManagement-paddingTop5-cqOMB {
	padding-top: 30px !important;
}

.AdminUserManagement-paddingTop6-E5w1u {
	padding-top: 36px !important;
}

.AdminUserManagement-paddingTop7-UQKGn {
	padding-top: 42px !important;
}

.AdminUserManagement-noPadding-cOqwr {
	padding: 0px !important;
}

.AdminUserManagement-textBold-qTsBp {
	font-weight: 500 !important;
}

.AdminUserManagement-textBolder-HvwdF {
	font-weight: 700 !important;
}

.AdminUserManagement-textNormal-kWi3a {
	font-weight: normal !important;
}

.AdminUserManagement-spaceBottom20-a6K3p {
	margin-bottom: 20px;
}

.AdminUserManagement-spaceBottom10-SQfqZ {
	margin-bottom: 10px;
}

.AdminUserManagement-marginNone-yHLlN {
	margin: 0;
}

.AdminUserManagement-spaceBottom15-l0XwI {
	margin-bottom: 15px;
}

.AdminUserManagement-marginTopNone-Htpdw {
	margin-top: 0;
}

.AdminUserManagement-spaceTop11-cJkKD {
	margin-top: 11px;
}

.AdminUserManagement-spaceTop21-RLhsD {
	margin-top: 21px;
}

.AdminUserManagement-spaceTop20-Ar7ko {
	margin-top: 20px;
}

.AdminUserManagement-spaceTop10-bDOU2 {
	margin-top: 10px;
}

/*New Design Text Colors */

.AdminUserManagement-textDarkBlue-uBREu {
	color: rgb(20, 39, 94) !important;
}

.AdminUserManagement-textLightBlue-SAw6L {
	color: rgb(57, 87, 106) !important;
}

.AdminUserManagement-textLightSandleGreen-cAgVC {
	color: rgb(76, 86, 41) !important;
}

.AdminUserManagement-textLightBrown-weJSz {
	color: rgb(115, 79, 33) !important;
}

.AdminUserManagement-textMediumMaroon-Ys5ZB {
	color: rgb(87, 37, 51) !important;
}

.AdminUserManagement-textBrown-qQozJ {
	color: rgb(160, 47, 24) !important;
}

.AdminUserManagement-textMaroon-I0CcL {
	color: rgb(155, 49, 67) !important;
}

.AdminUserManagement-textDarkBrown-ZM7D2 {
	color: rgb(83, 18, 16) !important;
}

.AdminUserManagement-textMediumBrown-Qd19I {
	color: rgb(142, 28, 10) !important;
}

.AdminUserManagement-textSkyBlue-Jqr79 {
	color: rgb(37, 117, 141) !important;
}

.AdminUserManagement-textGray-qX2oA {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AdminUserManagement-commonHeaderAdmin-UM9lq`,
	"adminLayout": `AdminUserManagement-adminLayout-HBMxc`,
	"box": `AdminUserManagement-box-EZer3`,
	"exportLink": `AdminUserManagement-exportLink-luVwH`,
	"blockCenter": `AdminUserManagement-blockCenter-Jav9G`,
	"panelHeader": `AdminUserManagement-panelHeader-PWkFN`,
	"currencyselect": `AdminUserManagement-currencyselect-XmPjW`,
	"mar0": `AdminUserManagement-mar0-gka2Z`,
	"sideAdminPageWrapper": `AdminUserManagement-sideAdminPageWrapper-L5Wb5`,
	"table": `AdminUserManagement-table-ZFskH`,
	"tableRow": `AdminUserManagement-tableRow-LliAI`,
	"tableCell": `AdminUserManagement-tableCell-OJr5R`,
	"formGroup": `AdminUserManagement-formGroup-f5j8g`,
	"select": `AdminUserManagement-select-C9_fK`,
	"noMargin": `AdminUserManagement-noMargin-ly1st`,
	"labelTextNew": `AdminUserManagement-labelTextNew-y_Q4N`,
	"displayInline": `AdminUserManagement-displayInline-bGpij`,
	"btnUPdate": `AdminUserManagement-btnUPdate-n2yH_`,
	"btnModalDelete": `AdminUserManagement-btnModalDelete-YnaFM`,
	"radioBtn": `AdminUserManagement-radioBtn-Cvl1g`,
	"backgroundImg": `AdminUserManagement-backgroundImg-Nn3uu`,
	"btnWidth": `AdminUserManagement-btnWidth-VVL0i`,
	"bannerImageBg": `AdminUserManagement-bannerImageBg-Ai7GH`,
	"bannerDelete": `AdminUserManagement-bannerDelete-CB9F9`,
	"modalRoot": `AdminUserManagement-modalRoot-COWDE`,
	"modalBorderBottom": `AdminUserManagement-modalBorderBottom-MM6vY`,
	"logInModalBody": `AdminUserManagement-logInModalBody-OWyGR`,
	"exportSection": `AdminUserManagement-exportSection-Ksscv`,
	"exportSectionGridSub": `AdminUserManagement-exportSectionGridSub-iQPvr`,
	"exportText": `AdminUserManagement-exportText-WQoZw`,
	"exportLinkImg": `AdminUserManagement-exportLinkImg-sgwe4`,
	"vtrMiddle": `AdminUserManagement-vtrMiddle-kbYYU`,
	"exportImg": `AdminUserManagement-exportImg-Oorff`,
	"profileViewlabel": `AdminUserManagement-profileViewlabel-uVHPb`,
	"profileViewMainContent": `AdminUserManagement-profileViewMainContent-iBBZD`,
	"profileViewMain": `AdminUserManagement-profileViewMain-o3C6R`,
	"profileViewInner": `AdminUserManagement-profileViewInner-loSub`,
	"profileImageSection": `AdminUserManagement-profileImageSection-aDJgl`,
	"lastviewInner": `AdminUserManagement-lastviewInner-wZIff`,
	"whyHostHoriLine": `AdminUserManagement-whyHostHoriLine-zHFDt`,
	"tableGrid": `AdminUserManagement-tableGrid-YWwhP`,
	"headingContent": `AdminUserManagement-headingContent-R9_Il`,
	"refundTextColor": `AdminUserManagement-refundTextColor-2Zn03`,
	"dividerLine": `AdminUserManagement-dividerLine-OfboY`,
	"smallContent": `AdminUserManagement-smallContent-DrTuW`,
	"ChangeToUpperCase": `AdminUserManagement-ChangeToUpperCase-GUwPY`,
	"noBorder": `AdminUserManagement-noBorder-t5Wmj`,
	"siteAdminHeading": `AdminUserManagement-siteAdminHeading-VmsMD`,
	"siteAdminSubHeading": `AdminUserManagement-siteAdminSubHeading-vMsud`,
	"adminFormDivider": `AdminUserManagement-adminFormDivider-BXF8z`,
	"space1": `AdminUserManagement-space1-vepwL`,
	"space2": `AdminUserManagement-space2-HfDXd`,
	"space3": `AdminUserManagement-space3-uMtkS`,
	"space4": `AdminUserManagement-space4-n2aUo`,
	"space5": `AdminUserManagement-space5-uJytu`,
	"space6": `AdminUserManagement-space6-mYwqS`,
	"space7": `AdminUserManagement-space7-BIDKI`,
	"spaceTop8": `AdminUserManagement-spaceTop8-m7k2y`,
	"spaceTop1": `AdminUserManagement-spaceTop1-DGQT5`,
	"spaceTop2": `AdminUserManagement-spaceTop2-mEzeG`,
	"spaceTop3": `AdminUserManagement-spaceTop3-XVHba`,
	"spaceTop4": `AdminUserManagement-spaceTop4-G_inQ`,
	"spaceTop5": `AdminUserManagement-spaceTop5-Sdnal`,
	"spaceTop6": `AdminUserManagement-spaceTop6-x47A9`,
	"spaceTop7": `AdminUserManagement-spaceTop7-duZtI`,
	"padding1": `AdminUserManagement-padding1-rRNf4`,
	"padding2": `AdminUserManagement-padding2-lJ_0d`,
	"padding3": `AdminUserManagement-padding3-N5pa1`,
	"padding4": `AdminUserManagement-padding4-cIMvk`,
	"padding5": `AdminUserManagement-padding5-YQlfN`,
	"padding6": `AdminUserManagement-padding6-uykWZ`,
	"padding7": `AdminUserManagement-padding7-BM7u2`,
	"paddingTop1": `AdminUserManagement-paddingTop1-HyE1D`,
	"paddingTop2": `AdminUserManagement-paddingTop2-B4UtC`,
	"paddingTop3": `AdminUserManagement-paddingTop3-hB7jL`,
	"paddingTop4": `AdminUserManagement-paddingTop4-ugJJc`,
	"paddingTop5": `AdminUserManagement-paddingTop5-cqOMB`,
	"paddingTop6": `AdminUserManagement-paddingTop6-E5w1u`,
	"paddingTop7": `AdminUserManagement-paddingTop7-UQKGn`,
	"noPadding": `AdminUserManagement-noPadding-cOqwr`,
	"textBold": `AdminUserManagement-textBold-qTsBp`,
	"textBolder": `AdminUserManagement-textBolder-HvwdF`,
	"textNormal": `AdminUserManagement-textNormal-kWi3a`,
	"spaceBottom20": `AdminUserManagement-spaceBottom20-a6K3p`,
	"spaceBottom10": `AdminUserManagement-spaceBottom10-SQfqZ`,
	"marginNone": `AdminUserManagement-marginNone-yHLlN`,
	"spaceBottom15": `AdminUserManagement-spaceBottom15-l0XwI`,
	"marginTopNone": `AdminUserManagement-marginTopNone-Htpdw`,
	"spaceTop11": `AdminUserManagement-spaceTop11-cJkKD`,
	"spaceTop21": `AdminUserManagement-spaceTop21-RLhsD`,
	"spaceTop20": `AdminUserManagement-spaceTop20-Ar7ko`,
	"spaceTop10": `AdminUserManagement-spaceTop10-bDOU2`,
	"textDarkBlue": `AdminUserManagement-textDarkBlue-uBREu`,
	"textLightBlue": `AdminUserManagement-textLightBlue-SAw6L`,
	"textLightSandleGreen": `AdminUserManagement-textLightSandleGreen-cAgVC`,
	"textLightBrown": `AdminUserManagement-textLightBrown-weJSz`,
	"textMediumMaroon": `AdminUserManagement-textMediumMaroon-Ys5ZB`,
	"textBrown": `AdminUserManagement-textBrown-qQozJ`,
	"textMaroon": `AdminUserManagement-textMaroon-I0CcL`,
	"textDarkBrown": `AdminUserManagement-textDarkBrown-ZM7D2`,
	"textMediumBrown": `AdminUserManagement-textMediumBrown-Qd19I`,
	"textSkyBlue": `AdminUserManagement-textSkyBlue-Jqr79`,
	"textGray": `AdminUserManagement-textGray-qX2oA`
};
module.exports = ___CSS_LOADER_EXPORT___;
